'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import Clarity from '@microsoft/clarity';
export const useClarity = projectId => {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== projectId) {
    t0 = () => {
      if (typeof window !== "undefined" && !window.clarity) {
        Clarity.init(projectId);
      }
    };
    t1 = [projectId];
    $[0] = projectId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};
export default useClarity;